import './SectionDescription.scss';

function SectionDescription(props) {
    let List = props.card.sectionDescription.map ((card, idx) =>
    {    
        return ( 
            <li key={idx}>{card.li}</li>
    )});
return (
    <div className='section-description'>
        <div className='section-description_line'>
            <div className='wrapper'>
                <div>
                    <ul>
                        {List}
                    </ul>
                    <p className='note'>Примечание: технические характеристики и конструктивные особенности могут быть изменены без предварительного уведомления.</p>
                </div>
            </div>
        </div>
    </div>
)}
export default SectionDescription;